<template>
  <div>
    <component
      ref="submodule"
      :is="currentView"      
      :module="module"
    />
  </div>
</template>
<script>
    import FairModule from './FairModule.vue'
    import LocationModule from './LocationModule.vue'
    import FinishModule from './FinishModule.vue'
    import AdditionalResultsModule from './AdditionalResultsModule.vue'
    import ModuleMixin from './Module.mixin.vue'

    export default {
        name: "Module",
        components: {
        },
        mixins: [ModuleMixin],
        props: {
            module: {
                type: Object,
                required: true
            },
            isLoading: {
                type: Boolean,
                default: true
            }
        },
        data: function() { return {
            
        }},
        computed: {
            currentView: function () {
                if(this.module.type === 'fair') {
                    return FairModule
                }

                if(this.module.type === 'location') {
                    return LocationModule
                }

                if(this.module.type === 'finish') {
                    return FinishModule
                }

                if(this.module.type === 'additionalResults') {
                    return AdditionalResultsModule
                }
            },
            isRdyToSend: function() {
                return this.$refs.submodule.isRdyToSend
            }
        },
        methods: {
            getResponseData() {
                return {
                    data: this.$refs.submodule.getResponseData(), 
                    id: this.module.id
                }
            }
        },
    }
</script>